import(/* webpackMode: "eager" */ "/app/src/app/contact/singapore/page.tsx");
